import { ProductItemPropsType } from '.';

export const ProductBellItemProps: ProductItemPropsType = {
	CartListItemProp: {
		size: undefined,
		color: undefined,
	},
	nameTypographyProps: {
		variant: 'h5',
	},
	subNameTypographyProps: {
		display: 'none',
	},
	quantityTypographyProps: {
		display: 'none',
	},
	quantityChangeTypographyProps: {
		display: 'none',
	},
	priceTypographyProps: {
		display: 'none',
	},
	unitPriceTypographyProps: {
		display: 'none',
	},
};
